import useApi from '@components/Hooks/useApi';
import useGlobalState from '@components/Hooks/useGlobalState';
import Fader from '@Shared/Fader';
import Paginator from '@Shared/Paginator';
import { IEvent, ISessionInfo, IUser } from '@src/interfaces';
import React, { useEffect, useRef, useState } from 'react';
import { Form, ListGroup } from 'react-bootstrap';
import Cookies from 'universal-cookie';
import ImpersonateUser from './User';
const cookies = new Cookies();

const ImpersonateUsers: React.FC = () => {

  const [store, dispatch] = useGlobalState();
  const api = useApi(dispatch);
  const [page, setPage] = useState<number>(1);
  const [keyword, setKeyword] = useState<string>('');
  const [selected, setSelected] = useState<number | null>(null);
  const [session,] = useState<string>(cookies.get('oasis_session' + api.getSubDomain()));
  const inputRef = useRef<HTMLInputElement>(null);
  const RECENT_KEY = 'impersonate_recent';
  const [recentUsers, setRecentUsers] = useState<IUser[]>(() => {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch { return []; }
  });

  console.log('rendering impersonate users');
  useEffect(() => {
    api.getUsers(1, '');
    console.log('focusing input');
    inputRef.current?.focus();
  }, []);

  useEffect(() => {
    if ((store.session as ISessionInfo)?.guid && session != (store.session as ISessionInfo)?.guid) {
      location.href = '/';
    }
  }, [(store.session as ISessionInfo)?.guid]);

  const search = (e: IEvent): void => {
    api.getUsers(1, e.currentTarget.value);
    setPage(1);
    setKeyword(e.currentTarget.value);
    setUser(null);
  }

  const updatePage = (num: number): void => {
    api.getUsers(num, keyword);
    setPage(num);
    setUser(null);
  }

  const setUser = (user_id: number | null) => {
    setSelected(user_id);
    if (user_id) {
      api.impersonate(user_id);
      const user = store.users?.users.find(u => u.id === user_id)
        ?? recentUsers.find(u => u.id === user_id);
      if (user) {
        console.log('updating recent users');
        setRecentUsers(prev => {
          const updated = [user, ...prev.filter(u => u.id !== user_id)].slice(0, 10);
          localStorage.setItem(RECENT_KEY, JSON.stringify(updated));
          return updated;
        });
      }
    }
  }

  const getPageCount = () => {
    return Math.max(Math.ceil((store.users?.count ?? 0) / 10), 1);
  }

  return (
    <>
      <Form.Group className='form-group'>
        <Form.Control ref={inputRef} type='text' onChange={search} placeholder='Search' />
      </Form.Group>
      {!!keyword && <Form.Group className='form-group'>
        <Paginator
          totalPages={getPageCount()}
          currentPage={Math.min(page, getPageCount())}
          onChange={updatePage}
        />
      </Form.Group>}
      <Form.Group className='form-group'>
        <Fader>
          {!keyword && recentUsers.length > 0 && (
            <ListGroup className='icon-list light-shadow'>
              {recentUsers.map((user: IUser) => (
                <ImpersonateUser key={user.id} user={user} active={selected} setter={setUser} />
              ))}
            </ListGroup>
          )}
          {!!keyword && !!store.users && (
            <ListGroup
              className={'icon-list ' + (store.users?.count ? 'light-shadow' : '')}
            >
              {store.users?.users.map((user: IUser) => {
                return (
                  <ImpersonateUser key={user.id} user={user} active={selected} setter={setUser} />
                )
              })}
            </ListGroup>
          )}
        </Fader>
      </Form.Group>
    </>
  );
}

export default ImpersonateUsers;